import { render } from "./GradeProcess.vue?vue&type=template&id=127d1a14&scoped=true&ts=true&lang=pug"
import script from "./GradeProcess.vue?vue&type=script&lang=ts"
export * from "./GradeProcess.vue?vue&type=script&lang=ts"

import "./GradeProcess.vue?vue&type=style&index=0&id=127d1a14&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d1a14"]])

export default __exports__